import { render, staticRenderFns } from "./UserMapping.vue?vue&type=template&id=04bf3ad9&"
import script from "./UserMapping.vue?vue&type=script&lang=js&"
export * from "./UserMapping.vue?vue&type=script&lang=js&"
import style0 from "./UserMapping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VDataTable,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VPagination,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04bf3ad9')) {
      api.createRecord('04bf3ad9', component.options)
    } else {
      api.reload('04bf3ad9', component.options)
    }
    module.hot.accept("./UserMapping.vue?vue&type=template&id=04bf3ad9&", function () {
      api.rerender('04bf3ad9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/UserMapping.vue"
export default component.exports